export default __webpack_public_path__ + "static/media/mysql.24a0fd20.png";